import React, { useEffect, useState } from "react";
import {
  Modal,
  getTheme,
  mergeStyleSets,
  FontWeights,
  DefaultButton,
  MessageBar, MessageBarType
} from "@fluentui/react";
import { Icon } from '@fluentui/react/lib/Icon';
 

function UploadForm({ isOpen, onDismiss, onSubmit, showLoader }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [showErrorAlert, setShowErrorAlert] = useState(false)

  useEffect(() => {
    setTitle('')
    setDescription('')
  }, [])

  const onInput = (e) => {
    const { name, value } = e.target;
    if (name === "title") setTitle(value);
    if (name === "description") setDescription(value);
  };

  const onChoosingFile = (e) => {
    const file = e.target.files[0];
    setFile(file);
  };

  const onUploadClick = () => {
    if(!title.length || !description.length || !file) {
      setShowErrorAlert(true)
      return
    }
    setShowErrorAlert(false)
    const formdata = new FormData();
    formdata.append("title", title);
    formdata.append("description", description);
    formdata.append("file", file, file.name);
    onSubmit(formdata);
  };

  return (
    <Modal isOpen={isOpen} containerClassName={contentStyles.container}>
      {showLoader ? (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p className="m-0">Uploading...</p>
        </div>
      ) : (
        <>
          <div className={contentStyles.header}>
            <p className="page-title m-0">Upload File</p>
            <DefaultButton
              styles={iconButtonStyles}
              ariaLabel="Close popup modal"
              onClick={onDismiss}
              className="mt-0"
            >
              <Icon iconName="ChromeClose" />
            </DefaultButton>
          </div>
          <div className="card p-3 m-3">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      Title <small>*</small>
                    </label>
                    <input
                      type="text"
                      name="title"
                      value={title}
                      placeholder="Enter title"
                      className="form-control"
                      onChange={onInput}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      Description <small>*</small>
                    </label>
                    <textarea
                      name="description"
                      placeholder="Enter Description"
                      className="form-control"
                      value={description}
                      onChange={onInput}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      File <small>*</small>
                    </label>
                    <input
                      onChange={onChoosingFile}
                      type="file"
                      multiple={true}
                      className="form-control"
                      style={{ padding: 4 }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <DefaultButton onClick={onUploadClick}>Upload</DefaultButton>
                </div>
                <div className="col-md-12 mt-3">
                  {showErrorAlert && (
                    <MessageBar
                      delayedRender={false}
                      messageBarType={MessageBarType.error}
                    >
                      Please fill all fields
                    </MessageBar>
                  )}
                </div>
              </div>
            </form>
          </div>
        </>
      )}
    </Modal>
  );
}

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "center",
    alignItems: "stretch",
    width: '80%',
    height: '80%'
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});

const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
    border: "none",
    outline: "none",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

export default UploadForm;
